<script>
import ApplicationRulesTable from "./application-rules-table";
import ApplicationRulesAction from "./application-rules-action";
import { permissionMixin } from "@/mixins/permissions";

export default {
  name: "ApplicationRules",
  mixins: [permissionMixin],
  data() {
    return {
      options: {}
    };
  },
  components: {
    ApplicationRulesAction,
    ApplicationRulesTable
  }
};
</script>

<template>
  <div id="application-rules__main-container">
    <v-subheader class="title" id="application-rules__main-title">
      <v-icon x-large class="mr-2" id="application-rules__main-title-icon"
        >mdi-book-open-variant</v-icon
      >
      {{ $t("modules.dataPath.applicationRules") }}
    </v-subheader>
    <v-divider></v-divider>
    <div v-if="isPermitted(PermissionEnum.APPLICATION_RULES.VIEW)">
      <application-rules-action />
      <application-rules-table />
    </div>
    <div v-else class="grey--text" id="application-rules__not-permitted">
      <v-container id="application-rules__not-permitted-container" fill-height>
        <v-layout align-center>
          <v-flex text-xs-center>
            <div>
              <v-icon size="50" color="grey">mdi-alert</v-icon>
            </div>
            <h3 class="display-1 font-weight-light">
              {{ $t("validation.notPermitted") }}
            </h3>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
  </div>
</template>
